export enum MultimediaThumbnailVariant {
  Mini = 'MINI',
  Medium = 'MEDIUM',
  Large = 'LARGE',
}
